import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, Toaster } from 'react-hot-toast';
import axios from "axios";
import { server } from "../../server";
import styles from "../../styles/styles";

export default function Auth() {
  const navigate = useNavigate();
  const [isLogin, setIsLogin] = useState(true);
  const [input, setInput] = useState('');
  const [otp, setOtp] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [isOtpSent, setIsOtpSent] = useState(false);

  const handleInputChange = (e) => {
    if (e.target.value){
      setInput(e.target.value);
    }
  };

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  }

  const handleSendOtp = async (e) => {
    e.preventDefault();
    // try {
    //   const response = await fetch(`${server}/api/auth/send-otp`, { method: 'POST', headers: { 'Content-Type': 'application/json' },  body: JSON.stringify({ input }), });
    //   const data = await response.json();
    //   if (response.ok) { setIsOtpSent(true); toast.success(data.message);
    //   } else { toast.error(data.message); }
    // } catch (error) { toast.error('Failed to send OTP'); }
    // console.log("isLogin => ", isLogin);
    // console.log("!isLogin =>>", !isLogin);
    // console.log("name => ", name);
    // console.log("password =>>", password);
    axios
      .post(`${server}/user/send-otp`, { input, isSignUp: !isLogin })
      .then((res) => {
        toast.success(res.data.message);
        setIsOtpSent(true);
      })
      .catch((error) => {
        // console.log('ERRRORRR ----', error);
        toast.error(error.response.data.message);
      });
  };

  // const handleSubmit = async (e) => { e.preventDefault();
  //   try { const endpoint = isLogin ? `${server}/api/user/login` : `${server}/api/user/signup`; const response = await fetch(endpoint, {
  //       method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ input, otp }), });
  //     const data = await response.json(); if (response.ok) { toast.success(data.message); navigate('/dashboard'); } else { toast.error(data.message); }
  //   } catch (error) { toast.error('Authentication failed'); } };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const endpoint = isLogin ? `${server}/user/login` : `${server}/user/signup`;
    await axios
      .post(
        endpoint,
        {
          input,
          otp,
          name,
          password
        },
        { withCredentials: true }
      )
      .then((res) => {
        toast.success("Login Success!");
        navigate("/");
        window.location.reload(true); 
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-cyan-300 to-cyan-200 py-12 px-4 sm:px-6 lg:px-8">
      <Toaster position="bottom-center" reverseOrder={false} />
      <div className="max-w-md w-full space-y-8 bg-white p-10 rounded-xl shadow-2xl transform transition-all duration-300 hover:scale-105">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            {isLogin ? 'Log in to your account' : 'Create Your Account'}
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            {isLogin ? 'Welcome !' : 'Sign up for a new account'}
          </p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm -space-y-px">
            {isOtpSent && !isLogin && (
              <div>
                <label htmlFor="name" className="sr-only">
                  Name
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  required
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                  placeholder="Enter Name"
                  value={name}
                  onChange={handleNameChange}
                />
              </div>
            )}
            <div>
              <label htmlFor="input" className="sr-only">
                Email
              </label>
              <input
                id="input"
                name="input"
                type="text"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Enter Email"
                value={input}
                onChange={handleInputChange}
              />
            </div>
            {isOtpSent && !isLogin && (
              <div>
                <label htmlFor="password" className="sr-only">
                  Password
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  required
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                  placeholder="Enter Password"
                  value={password}
                  onChange={handlePasswordChange}
                />
              </div>
            )}
            {isOtpSent && (
              <div>
                <label htmlFor="otp" className="sr-only">
                  OTP
                </label>
                <input
                  id="otp"
                  name="otp"
                  type="text"
                  required
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={handleOtpChange}
                />
              </div>
            )}
              
          </div>

          <div>
            {!isOtpSent ? (
              <button
                type="button"
                onClick={handleSendOtp}
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-300"
              >
                Request OTP
              </button>
            ) : (
              <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors duration-300"
              >
                {isLogin ? 'Sign In' : 'Sign Up'}
              </button>
            )}
          </div>

          <div className={`${styles.noramlFlex}`}>
            <input
              type="checkbox"
              name="remember-me"
              id="remember-me"
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
            />
            <label
              htmlFor="remember-me"
              className="ml-2 block text-sm text-gray-900"
            >
              Remember me
            </label>
          </div>
        </form>

        <div className="text-center">
          <button
            onClick={() => setIsLogin(!isLogin)}
            className="font-medium text-indigo-600 hover:text-indigo-500 transition-colors duration-300"
          >
            {isLogin ? "Don't have an account? Sign Up" : 'Already have an account? Sign In'}
          </button>
        </div>
      </div>
    </div>
  );
}

